export default {"src":"/_next/static/media/cvent-logo.db5c2f51.svg","height":28,"width":146};